import React, { useEffect, useState } from 'react';
import { Sector } from 'graphql-common';
import { ApolloClient, gql } from '@apollo/client';
import { ApolloError } from '@apollo/client/errors';
import ApolloClientSingleton from 'graphql-common/ApolloClient';
import Trans from '@lib/components/Trans/Trans';
import Typography from '@lib/components/Typography/Typography';
import SectorMapPopupContentLoading from './SectorMapPopupContentLoading';
import SectorMapPopupContent from './SectorMapPopupContent';
import styles from './SectorMapPopupContent.module.scss';

type Props = {
  sectorId: string;
  isOpen?: boolean;
};

const SECTOR_QUERY = gql`
  query Sector($id: ID!) {
    sector(id: $id) {
      id
      name
      code
    }
  }
`;

export default function SectorMapPopupContentAsyncWrap(props: Props) {
  const { sectorId, isOpen } = props;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<Sector | null>(null);
  const [error, setError] = useState<ApolloError | null>(null);

  const client: ApolloClient<any> = ApolloClientSingleton;

  useEffect(() => {
    if (isOpen && sectorId) {
      setLoading(true);
      setError(null);
      client
        .query({
          query: SECTOR_QUERY,
          variables: { id: sectorId },
        })
        .then((res) => {
          if (res.data?.sector) {
            setData(res.data.sector as Sector);
          }
          setLoading(false);
        })
        .catch((err: ApolloError) => {
          setError(err);
          setLoading(false);
        });
    }
  }, [sectorId, isOpen, client]);

  let content = <SectorMapPopupContentLoading />;
  if (!loading && data) {
    content = <SectorMapPopupContent sector={data} />;
  }
  if (error) {
    return (
      <Typography variant="body" className={styles.error}>
        <Trans i18nKey="failed-to-load-text" />
      </Typography>
    );
  }
  return content;
}
